import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { ReactNode } from 'react';

import { AppThemeProvider } from '@/app/providers/AppThemeProvider';
import { ErrorBoundary } from '@/app/providers/ErrorBoundary';
import { queryClient } from '@/services/api/query-client';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppThemeProvider>
          {children}
          {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
        </AppThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
